import React from 'react';
import DeleteSelf from '../components/DeleteSelf';

const DeleteAccount: React.FC = () => {
  return (
    <>
      <h2>Delete Account</h2>
      <DeleteSelf />
    </>
  );
};

export default DeleteAccount;
